export default "__VITE_ASSET__CwCzJE7h__"